import {gql} from "@apollo/client";

export const SET_AUTH = gql`
    query SetAuth {
        auth {
            isAuth
        }
    }
`;
